import {
    createSelector
} from "reselect";

export const ftlCostsSelector = createSelector(state => state && state.ftlCosts && state.ftlCosts.ftlCosts, ftlCostsSelector => ftlCostsSelector)
export const shippingCostsSelector = createSelector(state => state && state.ftlCosts && state.ftlCosts.shippingCosts, shippingCostsSelector => shippingCostsSelector)